import config from '@config';

export default function endCurrentSession(token?: string | null) {
  if (!token) {
    return;
  }
  try {
    fetch(`${config.host}/sessions/current`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    return;
  }
}
